import styled from 'styled-components';

import { mediaBreakpoint } from '../../../utils/mediaBreakpoint';

export const CappedMessageWrapper = styled.div`
  &&& {
    background-color:rgba(17, 117, 181, 0.06);
  }
`;

export const LoanOptionDescriptionDivWrapper = styled.div`
  &&& > ul {
    padding-left: 1.5rem;
  }
`;

export const LoanItemWrapper = styled.div`
  &&& {
    display: flex;
    flex-direction: column;
    max-width:100%;
    overflow-x: hidden;
  }
`;

export const LoanOptionWrapper = styled.div`
  &&& {
    display: flex;
    flex-grow: 10;
    flex-direction: column;
    justify-content: start;
    align-items: stretch;
    border-width: 1px;
    border-style: solid;
    border-color: ${({ theme }) => theme.Colors.Aliases.divider};
  }
  &&& > div {
    padding: ${({ theme }) => `0 ${theme.Spacing.spacing3x} 0 ${theme.Spacing.spacing3x}`};
  }
  &&& > p {
    padding: ${({ theme }) => `0 ${theme.Spacing.spacing3x} 0 ${theme.Spacing.spacing3x}`};
  }
  &&& > span {
    padding: ${({ theme }) => `0 ${theme.Spacing.spacing3x} 0 ${theme.Spacing.spacing3x}`};
  }
`;

export const OptionTabsWrapper = styled.div`
  &&& {
    list-style-type: none;
    display: flex;
    flex-wrap: nowrap;
    white-space: nowrap;
    padding-bottom: 1.5rem;
  }
`;

type OptionButtonProps = {
  isActive?: boolean;
};
export const OptionTabWrapper = styled.button<OptionButtonProps>`
  &&& {
    padding: 0.5rem 2rem 0.5rem 2rem;
    margin-right: 1px;
    border: ${({ isActive, theme }) =>
        (isActive ? `1px solid ${theme.Colors.Aliases.dividerAlt}` : `${theme.Colors.Aliases.backgroundLight}`)};
    background: ${({ isActive, theme }) => (isActive? `${theme.Colors.Aliases.backgroundLight}`:`${theme.Colors.Aliases.backgroundLightSecondary}`)};
  }
`;

export const ExceedInfoDivWrapper = styled.div`
  &&& {
    border-width: 1px;
    border-style: solid;
    border-color: ${({ theme }) => theme.Colors.Aliases.textAction};
    padding: 1rem;
    margin-bottom: 2rem;
  }
`;

type Props = {
  minHeight?: string;
};

export const ListWrapper = styled.ul<Props>`
  &&& {
    min-height: ${(props) => props.minHeight ?? '10vh'};
  }
  > li {
    list-style: disc !important;
  }
`;

export const ListNoDiscWrapper = styled.ul`
  &&& {
    list-style-type: none;
    padding-left: 1.5rem;
  }
`;

export const ListItemWrapper = styled.li`
  &&& {
    padding-bottom: 0.5rem;
  }
`;

export const OfferWrapper = styled.div`
  &&& {
    font-weight: 800;
  }
`;

export const RecommendPrimarySpanWrapper = styled.span`
  &&& {
    background-color: ${({ theme }) => theme.Colors.Aliases.brandBeacon};
    border-top-left-radius: 0.3125rem;
    border-top-right-radius: 0.3125rem;
    color: #1e1e1e;
    text-align: center;
    font-weight: 800;
    padding: 0.5rem;
  }
`;

export const RecommendSecondarySpanWrapper = styled.span`
  &&& {
    background-color: ${({ theme }) => theme.Colors.Aliases.backgroundLightSecondary};
    border-top-left-radius: 0.3125rem;
    border-top-right-radius: 0.3125rem;
    color: #1e1e1e;
    text-align: center;
    font-weight: 800;
    padding: 0.5rem;
  }
`;

export const LoanItemHeaderDivWrapper = styled.div`
  &&& {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-top: -0.5rem;
    margin-right: -1.5rem;
  }
  &&& > h4 {
    font-size: 1.25rem;
    min-height: 40px;
    ${mediaBreakpoint.down('md')} {
      font-size: 1rem;
    }
  }
`;

export const LoanItemDescriptionWrapper = styled.div`
  &&& {
    min-height: 60px;
    ${mediaBreakpoint.down('md')} {
      min-height: 80px;
    }
  }
`;

export const LoanItemHrWrapper = styled.hr`
  &&& {
    min-width: 100%;
  }
`;

export const LoanItemRepaymentContainerWrapper = styled.div`
  &&& > h4 {
    font-size: 0.875rem;
  }
  &&& .tooltip__content{
    left: -6rem;
    padding: 2rem;
    width: 16rem;
  }

  &&& .tooltip__content--top::after{
    left: 6rem;
  }

  &&& .tooltip__content--text{
    padding: 0;
  }
`;

export const LoanInterestDiscountWrapper = styled.div`
  &&& .tooltip__content{
    ${mediaBreakpoint.down('md')} {
      left: -8rem;
    }
    padding: 2rem;
    width: 16rem;
  }

  &&& .tooltip__content--top::after{
    ${mediaBreakpoint.down('md')} {
      left: 8rem;
    }
  }

  &&& .tooltip__content--text{
    padding: 0;
  }
`;

export const LoanItemRepaymentDivWrapper = styled.div`
  &&& {
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
  }
`;

export const LoanItemAccordionContainerWrapper = styled.div`
  &&& .accordion-header {
    padding: 0.5rem 0 0.5rem 0 !important;
    font-size: 0.875rem !important;
    font-weight: 800 !important;
  }
  .accordion-content {
    padding: 0 !important;
    padding-left: 0.25rem !important;
  }
`;

export const LoanItemSpanWrapper = styled.span`
  &&& {
    font-size: 2rem;
    font-weight: 800;
  }
`;

export const LoanItemOfferContainerDivWrapper = styled.div`
  &&& {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: start;
  }
`;

export const LoanItemOfferDivWrapper = styled.div<Props>`
  &&& {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: end;
    min-height: ${(props) => props.minHeight ?? '150px'};
    ${mediaBreakpoint.down('md')} {
      min-height: 210px;
    }
  }
`;

export const LoanItemLinkContainerDivWrapper = styled.div`
  &&& {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;
    ${mediaBreakpoint.down('md')} {
      flex-direction: column;
    }
  }
`;

export const LoanItemHyperLinkContainerDivWrapper = styled.div`
  &&& .btn-action--subtle{
    min-width:0 !important;
    padding:0 !important;
    margin: 0 !important;
  }
`;

